import Box from "@mui/material/Box";

const FieldHint = ({ text = "" }) => {
  return (
    <Box
      sx={{
        fontSize: "12px",
        color: "text.secondary",
        marginTop: "-2px",
        marginBottom: "8px",
        lineHeight: 1.4,
      }}
    >
      {text}
    </Box>
  );
};

export default FieldHint;
